export const USAStates = [
    {
        name: "Alabama",
        value: "AL",
    },
    {
        name: "Alaska",
        value: "AK",
    },
    {
        name: "Arizona",
        value: "AZ",
    },
    {
        name: "Arkansas",
        value: "AR",
    },
    {
        name: "California",
        value: "CA",
    },
    {
        name: "Colorado",
        value: "CO",
    },
    {
        name: "Connecticut",
        value: "CT",
    },
    {
        name: "Delaware",
        value: "DE",
    },
    {
        name: "District Of Columbia",
        value: "DC",
    },
    {
        name: "Florida",
        value: "FL",
    },
    {
        name: "Georgia",
        value: "GA",
    },
    {
        name: "Hawaii",
        value: "HI",
    },
    {
        name: "Idaho",
        value: "ID",
    },
    {
        name: "Illinois",
        value: "IL",
    },
    {
        name: "Indiana",
        value: "IN",
    },
    {
        name: "Iowa",
        value: "IA",
    },
    {
        name: "Kansas",
        value: "KS",
    },
    {
        name: "Kentucky",
        value: "KY",
    },
    {
        name: "Louisiana",
        value: "LA",
    },
    {
        name: "Maine",
        value: "ME",
    },
    {
        name: "Maryland",
        value: "MD",
    },
    {
        name: "Massachusetts",
        value: "MA",
    },
    {
        name: "Michigan",
        value: "MI",
    },
    {
        name: "Minnesota",
        value: "MN",
    },
    {
        name: "Mississippi",
        value: "MS",
    },
    {
        name: "Missouri",
        value: "MO",
    },
    {
        name: "Montana",
        value: "MT",
    },
    {
        name: "Nebraska",
        value: "NE",
    },
    {
        name: "Nevada",
        value: "NV",
    },
    {
        name: "New Hampshire",
        value: "NH",
    },
    {
        name: "New Jersey",
        value: "NJ",
    },
    {
        name: "New Mexico",
        value: "NM",
    },
    {
        name: "New York",
        value: "NY",
    },
    {
        name: "North Carolina",
        value: "NC",
    },
    {
        name: "North Dakota",
        value: "ND",
    },
    {
        name: "Ohio",
        value: "OH",
    },
    {
        name: "Oklahoma",
        value: "OK",
    },
    {
        name: "Oregon",
        value: "OR",
    },
    {
        name: "Pennsylvania",
        value: "PA",
    },
    {
        name: "Rhode Island",
        value: "RI",
    },
    {
        name: "South Carolina",
        value: "SC",
    },
    {
        name: "South Dakota",
        value: "SD",
    },
    {
        name: "Tennessee",
        value: "TN",
    },
    {
        name: "Texas",
        value: "TX",
    },
    {
        name: "Utah",
        value: "UT",
    },
    {
        name: "Vermont",
        value: "VT",
    },
    {
        name: "Virginia",
        value: "VA",
    },
    {
        name: "Washington",
        value: "WA",
    },
    {
        name: "West Virginia",
        value: "WV",
    },
    {
        name: "Wisconsin",
        value: "WI",
    },
    {
        name: "Wyoming",
        value: "WY",
    },
    {
        name: "Armed Forces Americas",
        value: "AA",
    },
    {
        name: "Armed Forces Pacific",
        value: "AP",
    },
    {
        name: "Armed Forces Others",
        value: "AE",
    },
    {
        name: "American Samoa",
        value: "AS",
    },
    {
        name: "Guam",
        value: "GU",
    },
    {
        name: "Northern Mariana Islands",
        value: "MP",
    },
    {
        name: "Puerto Rico",
        value: "PR",
    },
    {
        name: "United States Minor Outlying Islands",
        value: "UM",
    },
    {
        name: "Virgin Islands",
        value: "VI",
    },
];
export const canadaStates = [
    {
        name: "Alberta",
        value: "AB",
    },
    {
        name: "British Columbia",
        value: "BC",
    },
    {
        name: "Manitoba",
        value: "MB",
    },
    {
        name: "New Brunswick",
        value: "NB",
    },
    {
        name: "Newfoundland and Labrador",
        value: "NL",
    },
    {
        name: "Nova Scotia",
        value: "NS",
    },
    {
        name: "Ontario",
        value: "ON",
    },
    {
        name: "Prince Edward Island",
        value: "PE",
    },
    {
        name: "Quebec",
        value: "QC",
    },
    {
        name: "Saskatchewan",
        value: "SK",
    },
    {
        name: "Northwest Territories",
        value: "NT",
    },
    {
        name: "Nunavut",
        value: "NU",
    },
    {
        name: "Yukon",
        value: "YT",
    },
];
export const labelStyles = {
    color: "#070707",
    fontFamily: "Halyard Display !important",
    fontWeight: 200,
};
export const formControlStyles = {
    "& .MuiOutlinedInput-root": {
        ...labelStyles,
        "& > fieldset": {
            borderColor: "#d6d6d6 !important",
            borderWidth: "1px !important",
            fontFamily: "Halyard Display",
            fontWeight: 200,
        },
    },
};
export const CARD_OPTIONS = {
    showIcon: false,
    style: {
        base: {
            fontWeight: "200",
            fontFamily: "Halyard Display, Sans-Serif",
            fontSize: "20px",
            lineHeight: "1.25",
            fontSmoothing: "antialiased",
        },
        invalid: {
            color: "#E6473D",
        },
    },
};
export const USAStatesReverseMap = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FL": "Florida",
    "GA": "Georgia",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming",
    "AA": "Armed Forces Americas",
    "AP": "Armed Forces Pacific",
    "AE": "Armed Forces Others",
    "AS": "American Samoa",
    "GU": "Guam",
    "MP": "Northern Mariana Islands",
    "PR": "Puerto Rico",
    "UM": "United States Minor Outlying Islands",
    "VI": "Virgin Islands",
};
